"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetInAppPromotionResponse", {
    enumerable: true,
    get: function() {
        return GetInAppPromotionResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetInAppPromotionResponse = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    bannerCopy: _zod.z.string(),
    hyperlink: _zod.z.string(),
    type: _zod.z.string(),
    description: _zod.z.string(),
    bannerEnabled: _zod.z.boolean().nullish(),
    developmentOptions: _models.InAppPromotionDevelopmentOptionsModel.nullish(),
    companiesWithModule: _zod.z.boolean().nullish()
});
